var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { combineReducers } from "redux";
import currentUserDetailsReducersMapObject from "@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer";
import getWorkspaceReducersMapObject from "@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.ducks";
import UserAccessReducersMapObject from "@ane/exp-ux/lib/components/GetUserAccess/UserAccess.reducer";
import { upsellMessageDismissReducer, upsellMessageDismissAllReducer } from "./views/panel/ducks/index.js";
import { upsellMessageListReducer } from "./views/panel/ducks/upsellMessageList.duck.js";
import { messageCountReducer } from "./views/panel/ducks/messageCount.duck.js";
import { messageListReducer } from "./views/panel/ducks/messageList.duck.js";
import { messageDismissReducer } from "./views/panel/ducks/messageDismiss.duck.js";
import { messageDismissAllReducer } from "./views/panel/ducks/messageDismissAll.duck.js";
const moduleReducer = __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, currentUserDetailsReducersMapObject), getWorkspaceReducersMapObject), UserAccessReducersMapObject), {
  notificationModule: combineReducers({
    messageCount: messageCountReducer,
    messageList: messageListReducer,
    messageDismiss: messageDismissReducer,
    messageDismissAll: messageDismissAllReducer,
    upsellMessageList: upsellMessageListReducer,
    upsellMessageDismiss: upsellMessageDismissReducer,
    upsellMessageDismissAll: upsellMessageDismissAllReducer
  })
});
export {
  moduleReducer as default,
  moduleReducer
};
//# sourceMappingURL=reducers.js.map
